/**
 * ページの情報や各種一覧でIDを表示
 *
 * @param {Object} options
 * @param {Boolean} options.id `true` をセットするとIDをテーブルに表示します。
 *
 * 使用例:
 * debug();
 */
import { msg } from './msg.js';
import { makeField } from './makeField.js';

export function debug() {
    // Show the page information
    const body = document.body;
    const bodyID = body.id ? '#' + body.id.trim() : '';
    const bodyClass = '.' + body.className.replace(/ +/g, '.').trim();

    const pageInfo = [
        '<span id="mtapp-show-basename" class="font-monospace"></span>',
        '<span id="mtapp-debug-pageinfo-content" class="msg-text font-monospace">body' + bodyID + bodyClass + '</span>'
    ];

    msg({
        msg: pageInfo.join(''),
        type: 'info'
    });

    console.warn('mtappVars', mtappVars);

    const mainContent = document.querySelector('.mt-mainContent');

    if (mainContent) {
        const fields = Array.from(mainContent.querySelectorAll('div.field')).filter((field) => {
            return field.offsetWidth > 0 && field.offsetHeight > 0;
        });

        const fieldSort = [];

        fields.forEach((field) => {
            const basename = field.id.replace(/-field$/, '');
            fieldSort.push(basename);

            const input = document.createElement('input');
            input.type = 'text';
            input.value = basename;
            input.className = 'form-control font-monospace mt-4 mb-2 pl-2 bg-light border-light';
            input.disabled = true;
            input.setAttribute('readonly', true);

            field.before(input);
        });

        const fieldHtml = makeField({
            label: '現在の並び順',
            content: '<textarea id="mtapp-fieldsort" class="form-control font-monospace">' + fieldSort.join(',') + '</textarea>'
        });

        document.getElementById('msg-block').insertAdjacentHTML('afterend', fieldHtml);
    } else {
        document.getElementById('mtapp-show-basename').style.display = 'none';
    }
}
